export default __webpack_public_path__ + "static/media/legend_soil_types.980e0c70.png";